export default __webpack_public_path__ + "static/statuu-6d2f6eaaa424f95111ab7e0f3bc08292.jpg";